const CAR_EDIT_DISCLAIMER = `If the new limits are lower than the current Max Long Exposure
   or Max Short Exposure for any given product or expiry then only
    exposure reducing order will be accepted but current open orders
    will not be cancelled`;

export default CAR_EDIT_DISCLAIMER;
